export * from './People1BadgeIcon';
export * from './People1BadgeIcon16Light';
export * from './People1BadgeIcon16Regular';
export * from './People1BadgeIcon16Solid';
export * from './People1BadgeIcon20Light';
export * from './People1BadgeIcon20Regular';
export * from './People1BadgeIcon20Solid';
export * from './People1BadgeIcon24Regular';
export * from './People1BadgeIcon24Solid';
export * from './People1BadgeIcon32Regular';
export * from './People1BadgeIcon64Regular';
